module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_ice-90d257dcd7b3033cabdf91743ce9c42e.jpg";